export enum AppRoute {
    MySpace = '/',
    Login = '/login',
    AccessDenied = '/accessDenied',
    Error = '/error',
    Home = '/home',
    MobileLoginRedirect = '/mobileLoginRedirect',
}